import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/Services/api.service';
import { Observable } from 'rxjs';
import { UserData } from 'src/app/Services/data.model';
import { tap } from 'rxjs/operators';
import { ReportNotificationService } from './reportNotification.service';
import { environment } from 'src/environments/environment';
import { EntityWebsiteModel } from '../components/pages/schoolSetup/entityWesiteCrud/entityWebsiteCrud.model';
//import { ParentStudentModel } from '../components/pages/parentStudentQueries/parentStudentQueries.model';
import { ParentStudentModel } from '../components/pages/studentQueries/studentQueries.model';
import { ExpenseModel } from '../components/pages/expenseManagement/expenseManagement.model';



@Injectable({
  providedIn: 'root'
})
export class ProfileApiService {
  odPayDomain: string = environment.odPayDomain;

  browserDomain : string = this.service.browserDomain;
  constructor(private http: HttpClient, private service: ApiService, private reportNotificationService: ReportNotificationService) { }


  URLAddress(address){
    const FinalURL = this.service.URLAddress(address,'profile')
    return FinalURL; 
  }
  primaryColor = localStorage.getItem('primaryColour')
  passColour(){
    return this.primaryColor
  }

  checkCurrentDate(): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/getCurrentDate/dashboard') );
  }
  getEntityData(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/entity?id='+id) );
  }
  editEntityData(entityData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/entity"), entityData);
  }

  // Academic Session...
  getSessionList(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/session?entity=' +entityId))
  }
  getSessionList1(entityId,showArchived): Observable<UserData[]>{
    let queryParams =entityId
    if(showArchived){
      queryParams +='&showArchived='+showArchived
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/session?entity=' +queryParams))
  }

  addSession(sessionData):Observable<UserData[]>{
      return this.http.post<UserData[]>(this.URLAddress("/add/session"), sessionData);
  }

  getSessionData(sessionId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/session?id='+sessionId) );
  }

  editSessionData(sessionData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/session"), sessionData);
  }
  activateSession(sessionData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress("/activate/session"), sessionData);
  }
  editSessionNameData(sessionData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/editName/session"), sessionData);
  }

  //sessionGroups

  getSessionGroupList(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/sessionGroup?entity=' +entityId))
  }

  addSessionGroup(sessionGroupData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/sessionGroup"), sessionGroupData);
  }

  getSessionGroupData(sessionGroupId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/sessionGroup?id='+sessionGroupId) );
  }

  editSessionGroupData(sessionGroupData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/sessionGroup"), sessionGroupData);
  }

  // Course Info....

  
  getCourseList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/course?entity=' +entityId+'&session='+session))
  }
  getCourseListAll(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/listAll/course?entity=' +entityId+'&session='+session))
  }
  getCourseGroupList(entityId, session, courseGroup,isLeet): Observable<UserData[]>{
    let queryParms = entityId+'&session='+session
    if(courseGroup){
      queryParms = queryParms + '&courseGroup='+courseGroup;
    }
    if(isLeet){
      queryParms = queryParms + '&isLEET='+isLeet;
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/course?entity=' +queryParms))
  }
  addcourse(courseData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/course"), courseData);
  }

  getCourseData(entityId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/course?id='+entityId) );
  }

  editCourseData(courseData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/course"), courseData);
  }
  editCourseNameData(courseData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/editName/course"), courseData);
  }
  //  feeHead and category..
  viewFeeMasterData(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/feeMaster?entity=' +entityId+'&session='+session))
  }
  editFeeMasterData(feeMasterData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/feeMaster"), feeMasterData);
  }
  updateGroupFeeHead(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/feeMaster"), formData);
  }
  checkFeeHeadInUse(entityId, session, feeHead): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/checkFeeHeadInUse/feeMaster?entity='+entityId+'&session='+session+'&feeHead='+feeHead))
  }



  viewAdmissionMaster(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/admissionMaster?entity='+entityId+ '&session='+ session))
  }
  // Receipt Settings 
  viewReceiptMaster(entityId, session, receiptSessionDependency): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/receiptMaster?entity=' +entityId+'&session='+session+'&receiptSessionDependency='+receiptSessionDependency))
  }
  editReceiptMaster(receiptMasterData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/receiptMaster"), receiptMasterData);
  }

   //  Fine Config..
  viewFineConfig(entityId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/fineConfig?entity=' +entityId))
  }
  editFineConfig(feeMasterData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/fineConfig"), feeMasterData);
  }

  //fee group
  getFeeGroupList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/feeGroup?entity=' +entityId+'&session='+session))
  }
  addFeeGroup(feeGroupData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/add/feeGroup"), feeGroupData);
  }
  viewFeeGroup(feeGroupId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/feeGroup?id='+feeGroupId) );
  }
  editFeeGroup(feeGroupData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/feeGroup'), feeGroupData);
  }
  deleteFeeGroup(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/feeGroup?id='+id) );
  }

  //// Student Data....
  getStudentList(data): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/list/student'), data)
  }
  addStudentData(studentData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/student"), studentData);
  }
  viewStudentData(studentId, entityId, session, regNo): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/student?id='+studentId+ '&entity=' +entityId+'&session='+session+ '&regNo='+regNo) );
  }
  editStudentData(studentData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/student'), studentData);
  }
  editStudent(data):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/editStudent/student'), data);
  }
  editStudentDemand(studentData,sendAlert):Observable<UserData>{
    if(sendAlert){
      return this.http.post<UserData>(this.URLAddress('/editStudentDemand/student?sendAlert='+sendAlert), studentData);
    }else{
      return this.http.post<UserData>(this.URLAddress('/editStudentDemand/student'), studentData);
    }
  }
  addMissingStudentDemand(entityId, session):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/addMissingStudentDemand/student?entity=' +entityId+'&session='+session) );
  }
  toggleStudentStatus(id, remark, date,forceUpdate):Observable<UserData>{
    let queryParams = id+ '&remark='+ remark+ '&date='+date
    if(forceUpdate)
    {
      queryParams+='&forceUpdate='+forceUpdate
    }
    return this,this.http.get<UserData>(this.URLAddress('/toggleStatus/student?id='+queryParams))
  }
  updateRegNo(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateRegNo/student'), formData)
  }
  checkStudentDues(studentId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/checkDues/student?id='+studentId) );
  }
  checkAllSessionDues(entityId, regNo,): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/checkAllSessionDues/student?entity='+entityId+'&regNo='+regNo));
  }
  ////// file upload ...
  uploadStudentFile(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/addStudentsXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  uploadReportCard(qac,fileData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadReportCard?qac='+qac),fileData);
  }

  ///// term Groups .....
  listTermGroups( entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/termGroup?entity=' +entityId+ '&session=' +session));
  }
  addTerms(termsData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/termGroup'), termsData);
  }
  viewTermData(termId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/termGroup?id=' +termId));
  }
  editTerms(termsData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/termGroup'), termsData);
  }
  makeDefaultTerm(termsData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/makeDefault/termGroup'), termsData);
  }
  addTermCourse(termCourse): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/assignToClass/termGroup'), termCourse);
  }

  ///// Concession Fee Group.....
  getConcessionGroupList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/concession?entity=' +entityId+'&session='+session))
  }
  addConcessionGroup(concessionGroupData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/concession"), concessionGroupData);
  }
  viewConcessionGroup(concessionGroupId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/concession?id='+concessionGroupId) );
  }
  editConcessionGroup(concessionGroupData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/concession'), concessionGroupData);
  }
  assignStudentConcession(concessionData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/assignStudentConcession/student'), concessionData);
  }
  editStudentConcession(demandData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/editStudentConcession/student'), demandData);
  }
  copyConcessionGroupFromSession(entityId,fromSession,toSession): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/copyFromSession/concession?entity='+entityId+'&fromSession='+fromSession+'&toSession='+toSession));
  }

  //// Extra Fee Opening
  updateExtraFeeOpening(data): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateExtraFeeOpening/student'), data);
  }

////Refund 

getRefundDetails(studentId,refundType): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getRefundDetails/refundTransaction?studentId='+studentId +'&refundType='+refundType) );
 }
saveRefundDetails(refundData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveTransaction/refundTransaction'), refundData);
   }
 listRefundTransaction(entityId, session, startDate, endDate, status, search, pageNumber, pageSize,id,voucherStatus, courses?: any): Observable<UserData[]>{
  let queryParms = entityId+ '&session=' +session;
  if(search){
    queryParms = queryParms + '&search=' +search;
  }
  if(startDate){
    queryParms = queryParms + '&startDate=' +startDate;
  }
  if(endDate){
    queryParms = queryParms + '&endDate=' +endDate;
  }
  if(status){
    queryParms = queryParms + '&status=' +status;
  }
  if(pageNumber){
    queryParms = queryParms + '&pageNumber=' +pageNumber;
  }
  if(pageSize){
    queryParms = queryParms + '&pageSize=' +pageSize;
  }
  if(id){
    queryParms = queryParms+'&student='+id;
  }
  if(voucherStatus)
  {
    queryParms = queryParms+'&voucherStatus=' + voucherStatus;
  }
  let body: any = null;
  if (courses && courses.length > 0) {
    body = { course: courses };
  }
  return this.http.post<UserData[]>(this.URLAddress('/list/refundTransaction?entity=' +queryParms), body);
} 
listAdmissionRefundTransaction(entityId, session, startDate, endDate, status, search, pageNumber, pageSize,id,voucherStatus): Observable<UserData[]>{
  let queryParms = entityId+ '&session=' +session;
  if(search){
    queryParms = queryParms + '&search=' +search;
  }
  if(startDate){
    queryParms = queryParms + '&startDate=' +startDate;
  }
  if(endDate){
    queryParms = queryParms + '&endDate=' +endDate;
  }
  if(status){
    queryParms = queryParms + '&status=' +status;
  }
  if(pageNumber){
    queryParms = queryParms + '&pageNumber=' +pageNumber;
  }
  if(pageSize){
    queryParms = queryParms + '&pageSize=' +pageSize;
  }
  if(id){
    queryParms = queryParms+'&studentData='+id;
  }
  if(voucherStatus)
  {
    queryParms = queryParms+'&voucherStatus=' + voucherStatus;
  }
  return this.http.get<UserData[]>(this.URLAddress('/list/refundTransaction?entity=' +queryParms))
} 

viewRefundTransaction(transactionId): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/refundTransaction?id='+transactionId));
}

deleteRefundTransactionListReceipt(id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/delete/refundTransaction?id='+id));
}



/////// Take Fee Search.......
searchStudent(name, entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+name +'&entity=' +entityId+'&session='+session) );
}
searchStudentActive(name, entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+name +'&entity=' +entityId+'&session='+session+'&status=true') );
}
searchByStudentWithCourse(name, entityId, session,searchBy,course): Observable<UserData[]>{
  let queryParms = name+ '&entity=' +entityId+ '&session=' +session;
  if(searchBy){
    queryParms = queryParms+'&searchBy=' + searchBy;
  }
  return this.http.post<UserData[]>(this.URLAddress('/search/student?search='+ queryParms),{course:course} );
}
searchByStudent(name, entityId, session,searchBy): Observable<UserData[]>{
  let queryParms = name+ '&entity=' +entityId+ '&session=' +session;
  if(searchBy){
    queryParms = queryParms+'&searchBy=' + searchBy;
  }
  return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+ queryParms) );
}
viewStudentFeeData(data): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/getStudentFeeData/transaction'), data);
}
searchStudentFeeAllSession(entity,name): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/searchStudentDetails/student?entity='+entity +'&search='+name) );
}

fetchStudentId(entityId,session,regNo): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/fetchStudentByRegNo/student?entity='+entityId +'&session='+session+'&regNo='+regNo) );
}


/////proceed to pay.......
saveTransaction(payData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/saveTransaction/transaction'), payData);
}
saveOtherIncomeTransaction(payData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/saveTransaction/otherIncomeTransaction'), payData);
}
listTransaction(entityId, session, startDate, endDate, status, search, pageNumber, pageSize,voucherStatus,studentRegNo,receiptId): Observable<UserData[]>{
  let queryParms = entityId
  if(session){
    queryParms = queryParms+'&session=' +session;
  }
  if(search){
    queryParms = queryParms + '&search=' +search;
  }
  if(startDate){
    queryParms = queryParms + '&startDate=' +startDate;
  }
  if(endDate){
    queryParms = queryParms + '&endDate=' +endDate;
  }
  if(status){
    queryParms = queryParms + '&status=' +status;
  }
  if(pageNumber){
    queryParms = queryParms + '&pageNumber=' +pageNumber;
  }
  if(pageSize){
    queryParms = queryParms + '&pageSize=' +pageSize;
  }
  if(voucherStatus){
    queryParms = queryParms + '&voucherStatus=' + voucherStatus
  }
  if(studentRegNo){
    queryParms = queryParms + '&studentRegNo=' +studentRegNo
  }
  if(receiptId){
    queryParms = queryParms +'&receiptId=' + receiptId;
  }
  return this.http.get<UserData[]>(this.URLAddress('/list/transaction?entity=' +queryParms))
}
listOtherIncomeTransaction(entityId, session, startDate, endDate, status, search, pageNumber, pageSize,voucherStatus): Observable<UserData[]>{
  let queryParms = entityId
  if(session)
  {
    queryParms+= '&session=' +session;
  }
 
  if(search){
    queryParms = queryParms + '&search=' +search;
  }
  if(startDate){
    queryParms = queryParms + '&startDate=' +startDate;
  }
  if(endDate){
    queryParms = queryParms + '&endDate=' +endDate;
  }
  if(status){
    queryParms = queryParms + '&status=' +status;
  }
  if(pageNumber){
    queryParms = queryParms + '&pageNumber=' +pageNumber;
  }
  if(pageSize){
    queryParms = queryParms + '&pageSize=' +pageSize;
  }
  if(voucherStatus)
  {
    queryParms = queryParms + '&voucherStatus=' + voucherStatus;
  }
  return this.http.get<UserData[]>(this.URLAddress('/list/otherIncomeTransaction?entity=' +queryParms))
}
listStudentTransaction(formData): Observable<UserData[]>{

  return this.http.post<UserData[]>(this.URLAddress('/list/transaction'),formData)
}
viewTransaction(transactionId): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/transaction?id='+transactionId));
}
editTransaction(formData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/transaction'), formData)
}
editOtherIncomeTransaction(formData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/otherIncomeTransaction'), formData)
}
deleteTransaction(transactionId): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/delete/transaction?id='+transactionId));
}
viewOtherIncomeTransaction(transactionId): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/otherIncomeTransaction?id='+transactionId));
}
cancelReceipt(receiptData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/cancelReceipt/transaction'),receiptData);
}
cancelRefundReceipt(receiptData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/cancel/refundTransaction'),receiptData);
}
cancelOtherIncomeReceipt(receiptData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/cancelReceipt/otherIncomeTransaction'),receiptData);
}
listDailyFeeReport(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/dailyFeeReport/feeReports'),formData)
}
listDueFeeReport( dueFeeReportData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/dueFeeReport/feeReports'), dueFeeReportData)
}
listMultiSessiontDueFeeReport( multiSessionDueFeeReportData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/multiSessionDueFeeReport/feeReports'), multiSessionDueFeeReportData)
}
listConcessionReport( concessionReportData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/concessionReport/feeReports'), concessionReportData)
}
listDailyFeeHeadCollectionReport(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/dailyFeeHeadCollection/feeReports'),formData)
}
listDailyPaymentModeCollectionReport(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/dailyPaymentModeCollection/feeReports'),formData)
}
listCombinedDailyCollectionReport(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/combinedDailyCollectionReport/feeReports'),formData)
}
listConcessionUtilizationReport( formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/concessionUtilizationReport/feeReports'), formData)
}
promoteAll(formData):Observable<any>{
  return this.http.post<any>(this.URLAddress('/addAllStudentsToSession/studentSessionManagementConfig'),formData)
}

///Manage Cash
listManageCash(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/manageCash/feeReports'),formData)
}



////// Vehicle  .........
uploadDocument(qac, fileData): Observable<any> {
  return this.http.post<any>(this.URLAddress('/uploadDocument?qac=' + qac), fileData);
}



//////vehicleRoute............


//////SubjectCombination...........

assignSubjectCombination(subjectCombinationData):  Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/assignSubjectCombination/student'), subjectCombinationData)
}

///////User Crud.........
listUsers(entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/list/user?entity='+entityId+ '&session=' +session))
}
addUser(userData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/add/user'), userData)
}
viewUser(userId): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/user?id='+userId))
}
editUser(userData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/user'), userData)
}

/////GroupCRUD.......
addPermissionGroup(userData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/add/permissionGroup'), userData)
}
listPermissionGroups(entityId): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/list/permissionGroup?entity='+entityId))
}
viewPermissionGroup(id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/permissionGroup?id='+id))
}
getAdminPermissions(id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getAdminPermissions/user?entity='+id))
}
editPermissionGroup(userData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/permissionGroup'), userData)
}
deletePermissionGroup(id): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/delete/permissionGroup?id='+id), {})
}
assignPermissionGroup(id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/assign/permissionGroup?id='+id))
}
//////Attendance ..........
viewAttendanceMaster(entityId, session): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/attendanceMaster?entity=' +entityId+'&session='+session))
}
editAttendanceMaster(attendanceMasterData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress("/edit/attendanceMaster"), attendanceMasterData);
}
listStudentAttendance(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/list/studentAttendance'), formData)
}
listStudentAttendanceNew(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/list/studentAttendanceNew'), formData)
}
editListStudentAttendance(entityId, session, date, attendanceData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/editList/studentAttendance?entity=' +entityId+'&session='+session+'&date='+date), attendanceData)
}
addMissingStudentAttendance(entityId, session): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/addMissingStudentAttendance/studentAttendance?entity=' +entityId+'&session='+session))
}
listSchoolCaledar(entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/list/schoolCalendar?entity=' +entityId+'&session='+session))
}
addSchoolCalendar(schoolCaledarData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress("/add/schoolCalendar"), schoolCaledarData);
}
viewSchoolCalendar(Id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/schoolCalendar?id='+Id))
}
editSchoolCalendar(schoolCaledarData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress("/edit/schoolCalendar"), schoolCaledarData);
}
assignSchoolCalendar(schoolCaledarData):Observable<any>{
  return this.http.post<any>(this.URLAddress("/assign/schoolCalendar"), schoolCaledarData);
}

viewEntityPreferences(id):Observable<any>{
  return this.http.get<any>(this.URLAddress('/view/entityPreferences?entity='+id))
}
editEntityPreferences(preferencesData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/entityPreferences'), preferencesData)
}
viewUserPreferences(entityId): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/userPreferences?user=' +entityId))
}
editUserPreferences(preferencesData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/userPreferences'), preferencesData)
}


/////////////// Dashboard .............

getDashboardData(entityId, session,admissionSession): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getDashboardData/dashboard?entity=' +entityId+'&session='+session+'&admissionSession='+admissionSession))
}
getFeeCollectionGraphData(entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/getFeeCollectionGraphData/dashboard?entity=' +entityId+'&session='+session))
}

getFeeDataDashboard(entityId,session): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getFeeData/dashboard?entity=' +entityId+'&session='+session))
}
getFeeCourseWiseData(formData):Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/courseWiseCollection/feeReports'),formData);
}
getAdmissionDataDashboard(entityId,session,admissionSession): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getAdmissionData/dashboard?entity=' +entityId+'&session='+session+'&admissionSession='+admissionSession));
}
getAdmissionStageCountData(entityId,admissionSession):Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/getCountByStages/admissionStudentData?entity='+entityId+'&session='+admissionSession));
}
getInstituteSummary(formData):Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/instituteSummary/studentAttendance'),formData);
}
getInstituteSummaryNew(formData):Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/instituteSummary/studentAttendanceNew'),formData);
}

getEmployeeCalendar(entityId,session,employee,weekStartDate,weekEndDate):Observable<UserData>{
return this.http.get<UserData>(this.URLAddress('/employeeSchedule/timeTable?entity='+entityId+'&session='+session+'&employee='+employee+'&startDate='+weekStartDate+'&endDate='+weekEndDate))
}
getEmployeeCalendarNew(entityId,session,employee,weekStartDate,weekEndDate):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/employeeSchedule/employeeCalendar?entity='+entityId+'&session='+session+'&employee='+employee+'&startDate='+weekStartDate+'&endDate='+weekEndDate))
  }
viewEmployee(id):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/employee?id='+id));
}

getAnalyticsData(entityId, session, formData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/getAnalyticsData/dashboard?entity=' +entityId+'&session='+session), formData)
}

getAdmissionData(entityId, session, data):Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/admissionData/analyticsDashboard?entity='+entityId+'&session='+session), data)
}


 importReceipt(entityId, session, fileData): Observable<any>{
  return this.http.post<any>(this.URLAddress('/importReceipts/transaction?entity=' +entityId+'&session='+session), fileData)
}
importAutoReceipt(entityId, session,sessionEndDate, fileData): Observable<any>{
  return this.http.post<any>(this.URLAddress('/importAutoReceipts/transaction?entity=' +entityId+'&session='+session+'&sessionEndDate='+sessionEndDate), fileData)
}

syncStudentPermissions(entityId, session): Observable<any>{
  return this.http.get<any>(this.URLAddress('/syncStudentPermissions/student?entity=' +entityId+'&session='+session))
}
viewLibraryMaster(entityId):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/libraryMaster?entity='+entityId))
}
getLibraryDashboardData(entityId):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getLibraryData/dashboard?entity='+entityId))
}
uploadStudentPhoto(id, qac, fileData): Observable<any>{
  return this.http.post<any>(this.URLAddress('/uploadStudentPhoto?id=' +id+'&qac='+qac), fileData)
}
syncStudentDetails(studentData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/editStudent/student'), studentData);
}
updateTcDetails(studentData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/updateTC/student'), studentData);
}
checkReceiptsAndEditStudent(studentData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/checkReceiptsAndEdit/student'), studentData);
}
shiftCourse(studentData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/shiftStudentCourse/student'), studentData);
}
listAdmissionStageSetup(entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/list/admissionStageSetup?entity='+entityId+'&session='+session))
}
resetUserPassword(id, password): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/resetPassword/user?id='+id+'&password='+password))
}
listSubject(entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/list/subject?entity='+entityId+ '&session='+ session))
}
listSubjectCombination(entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/list/subjectCombination?entity='+entityId+ '&session='+ session))
}
addSubjectCombination(formData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/add/subjectCombination'), formData)
}
viewSubjectCombination(id):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/subjectCombination?id='+id))
}
editSubjectCombination(formData):Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/subjectCombination'), formData)
}
listAdmissionStudentData(formData): Observable<UserData>{
  // let queryParams = entityId +'&session='+session;
  
  // if(search){
  //   queryParams = queryParams + '&search='+search
  // }
  // if(pageSize){
  //   queryParams = queryParams + '&pageSize='+pageSize
  // }
  // if(pageNumber){
  //   queryParams = queryParams + '&pageNumber='+pageNumber
  // }

  return this.http.post<UserData>(this.URLAddress('/list/admissionStudentData'),formData)
}


getSISDashboard(entity,session):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getSISDashboard/dashboard?entity='+entity+'&session='+session))
}
getAdmissionDashboard(entity,session,admissionSession):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getAdmissionDashboard/dashboard?entity='+entity+'&session='+session+'&admissionSession='+admissionSession))
}
getFeeDashboard(entity,session):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getFeeDashboard/dashboard?entity='+entity+'&session='+session))
}
getLibraryDashboard(entity,session):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getLibraryDashboard/dashboard?entity='+entity+'&session='+session))
}
getEmployeeDashboard(entity,session,leaveCycleName, leaveCycleStartDate, leaveCycleEndDate,employeeType):Observable<UserData>{
  let queryParams = entity +'&session='+session+'&leaveCycleName='+leaveCycleName+'&leaveCycleStartDate='+leaveCycleStartDate+'&leaveCycleEndDate='+leaveCycleEndDate;
  if(employeeType){
    queryParams = queryParams + '&employeeType='+employeeType
  }
  return this.http.get<UserData>(this.URLAddress('/getEmployeeDashboard/dashboard?entity='+queryParams))
}
getExaminationDashboard(entity,session):Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getExaminationDashboard/dashboard?entity='+entity+'&session='+session))
}
getHodDashboard(entity,session,leaveCycleName, leaveCycleStartDate, leaveCycleEndDate,hodEmployee,employeeType):Observable<UserData>{
  let queryParams = entity +'&session='+session+'&leaveCycleName='+leaveCycleName+'&leaveCycleStartDate='+leaveCycleStartDate+'&leaveCycleEndDate='+leaveCycleEndDate+'&hodEmployee='+hodEmployee;
  if(employeeType){
    queryParams = queryParams + '&employeeType='+employeeType
  }
  return this.http.get<UserData>(this.URLAddress('/getHODDashboard/dashboard?entity='+queryParams))
}





  //upload Combination Excel
  uploadSubjectCombinationXl(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadSubjectCombinationXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  importSubjectCombinationXl(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importSubjectCombinationXL/subjectCombination?entity=' +entityId+'&session='+session), fileData)
  }

  //Gallery
  listGallery(entity,parent): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/gallery?entity='+entity+'&parent='+parent))
  }
  addGallery(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/gallery'), formData)
  }
  uploadGallery(Id, qac, formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadGallery?qac=' +qac+'&id='+Id), formData)
  }

  //odpayApi 


  getEntityId(entityId,branchId): Observable<any>{
    let queryParams = entityId 
  
    if(branchId){
      queryParams = queryParams + '&branchId='+branchId
    }
    return this.http.get<any>(this.odPayDomain+'/api/getEntityForERP/entity?odErpEntityId='+queryParams)
  }
  loginWithoutOTP(phone): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/loginWithoutOTP",{
      phone: phone,
    })
  }

  getDataFromODpay(odPayEntityId,regNo,erpSession): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/search/student",{
      entity: odPayEntityId,
      enrollmentNumber: regNo,
      erpSession:erpSession
    })
  }
  getDataFromODpayOtherIncome(odPayEntityId,regNo,erpSession): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/search/student",{
      entity: odPayEntityId,
      enrollmentNumber: regNo,
      erpSession:erpSession,
      erpTransactionType:"otherIncome" 
    })
  }
  recentPaymentCheck(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/recentPaymentCheck/payment",formData)
  }
  processPayment(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/process/payment",formData)
  }
  applyCharges(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/apply/chargesCategory",formData)
  }
  initiateTxn(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/initiateTxn/payment",formData)
  }
  resetUserPasswordFromERP(userId,pass) : Observable<any>{
    return this.http.post<any>(this.odPayDomain+'/resetPasswordFromERP?userId='+userId,{
      userId:userId,
      password:pass
    })
  }
  
  viewByTxnId(txnId,entityId):Observable<any>{
    return this.http.get<any>(this.URLAddress('/viewByTxnId/transaction?txnId='+txnId+'&entity='+entityId))
  }
  viewByOnlineTxnId(txnId):Observable<any>{
    return this.http.get<any>(this.URLAddress('/viewByTxnId/otherIncomeTransaction?txnId='+txnId))
  }


  uploadStudentConcessionDocument(qac,formData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadStudentConcessionDocument?qac='+qac),formData)
  }
  
  uploadDemandDocument(qac,formData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadDemandDocument?qac='+qac),formData)
  }

  reSyncStudentPermission(entity,session,regNo): Observable<any>{
    return this.http.get<any>(this.URLAddress('/reSyncStudentPermissions/student?entity=' +entity+'&session='+session+'&regNo='+regNo))
  }

  //student session Management Crud
  getStudentSessionManagementConfig(entityId):Observable<any>{
    return this.http.get<any>(this.URLAddress('/list/studentSessionManagementConfig?entity='+entityId))
  }
  viewStudentSessionManagementConfig(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/studentSessionManagementConfig?id='+id))
  }
  addStudentSessionManagementConfig(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/studentSessionManagementConfig'),formData)
  }
  editStudentSessionManagementConfig(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/studentSessionManagementConfig'),formData)
  }
  deleteStudentSessionManagementConfig(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/delete/studentSessionManagementConfig?id='+id))
  }

  //hostel  






  getCount():Observable<any>{
    return this.http.get<any>(this.URLAddress('/getCounts/superDashboard'))
  }
  getActiveStudents(startDate,endDate):Observable<any>{
    return this.http.get<any>(this.URLAddress('/getActiveStudents/superDashboard?startDate='+startDate+'&endDate='+endDate))
  }
  getOnlineFeePayments(startDate,endDate):Observable<any>{
    return this.http.get<any>(this.URLAddress('/getOnlineFeePayments/superDashboard?startDate='+startDate+'&endDate='+endDate))
  }
  getCommunicationReport(startDate,endDate):Observable<any>{
    return this.http.get<any>(this.URLAddress('/getCommunicationReport/superDashboard?startDate='+startDate+'&endDate='+endDate))
  }
  getUserByEntity(startDate,endDate):Observable<any>{
    return this.http.get<any>(this.URLAddress('/getUsersByEntity/superDashboard?startDate='+startDate+'&endDate='+endDate))
  }
  getEntityCountByLocation(location):Observable<any>{
    return this.http.get<any>(this.URLAddress('/getEntityCountByLocation/superDashboard?location='+location))
  }
  getEntityCountByModule():Observable<any>{
    return this.http.get<any>(this.URLAddress('/getEntityCountByModule/superDashboard'))
  }

  //pdfTemplate Crud



  //workflow


  viewStudentMaster(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/studentMaster?entity='+entityId+ '&session='+ session))
  }


  //timeline
  addTimeline(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/studentTimeline'),formData)
  }  
  editTimeline(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/studentTimeline'),formData)
  }  
  viewTimeline(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/studentTimeline?id='+id))
  }
  listTimeline(entity,userName,userMobile,isAdmin,studentDetailsId,privacy):Observable<any>{
    return this.http.get<any>(this.URLAddress('/list/studentTimeline?entity='+entity+'&userName='+userName+'&userMobile='+userMobile+'&isAdmin='+isAdmin+'&studentDetailsId='+studentDetailsId+'&privacy='+privacy))
  }
  uploadTimelineAttachement(qac,file):Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadStudentTimelineAttachment?qac=qac'+qac),file);
  }
  sendTimeLineNotification(id,entity):Observable<any>{
    return this.http.get<any>(this.URLAddress('/sendStudentTimeline/notifications?id='+id+'&entity='+entity))
  }
  deleteTimeLine(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/delete/studentTimeline?id='+id))
  }





  saveMetaData(id,model,data):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveMetadata?id='+id+'&model='+model), data)
  }


 

  saveLessons(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/saveLessonCovered/timeTable'),formData)
  }


  listSubjectCount(formData):Observable<any[]>{
    return this.http.post<any[]>(this.URLAddress('/subjectCount/studentReports'),formData)
  }
  listSubjectCombinationCount(formData):Observable<any[]>{
    return this.http.post<any[]>(this.URLAddress('/subjectCombinationCount/studentReports'),formData)
  }

  updateMobileNumber(formData):Observable<any[]>{
    return this.http.post<any[]>(this.URLAddress('/updateStudentPhone/student'),formData)
  }

  //FAQ

  listFaq(page):Observable<any>{
    return this.http.get<any>(this.URLAddress('/list/faq?page='+page))
  }


  //
  copyFromSession(entity,fromSession,toSession): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/copyFromSession/subjectCombination?entity='+entity+ '&fromSession='+ fromSession+'&toSession='+toSession))
  }
  deleteConcessionGroup(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/concession?id='+id) );
  }
  copyFromSessionFeeMaster(entity,fromSession,toSession): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/copyFromSession/feeMaster?entity='+entity+ '&fromSession='+ fromSession+'&toSession='+toSession))
  }



  //siblings

  saveSibings(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/saveSibling/student'),formData)
  }
  removeSibling(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/removeSibling/student?removedSibling='+id))
  }
  getSilingReports(id,session,course,stream,batch,section):Observable<any>{
    let quaryParams = id+'&session='+session
    if(course){
      quaryParams+='&course='+encodeURIComponent(course)
    }
    if(stream){
      quaryParams+='&stream='+stream
    }
    if(batch){
      quaryParams+='&batch='+batch
    }
    if(section){
      quaryParams+='&section='+section
    }
    return this.http.get<any>(this.URLAddress('/siblingReport/studentReports?entity='+quaryParams))
  }

  moveApplicationData(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/moveToEntity/admissionStudentData'),formData)
  }

  uploadDocumentLogo(qac,fileData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadDocument?qac='+qac),fileData);
  }

  viewAdmissionTransaction(transactionId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/admissionTransaction?id='+transactionId));
  }
  editAdmissionTransaction(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/admissionTransaction'), formData)
  }


  admissionReports(entityId,session,course,stream,batch): Observable<UserData[]>{

    let queryParams = entityId+'&session='+session

    if(course)
    {
      queryParams+='&course='+encodeURIComponent(course)
    }
    
    if(stream)
    {
      queryParams+='&stream='+stream
    }
    
    if(batch)
    {
      queryParams+='&batch='+batch
    }
    return this.http.get<UserData[]>(this.URLAddress('/subjectCombinationReport/admissionReports?entity='+queryParams));
  }


  listNepSubjects(entityId,session,course,stream,batch,groupBy,type): Observable<UserData[]>{

    let queryParams = entityId+'&session='+session

    if(course)
    {
      queryParams+='&course='+encodeURIComponent(course)
    }
    
    if(stream)
    {
      queryParams+='&stream='+stream
    }
    
    if(batch)
    {
      queryParams+='&batch='+batch
    }
    queryParams+="&groupBy="+groupBy+'&nepSubjectType='+type
    return this.http.get<UserData[]>(this.URLAddress('/nepSubjectReport/admissionReports?entity='+queryParams));
  }
  deletSubjectCombination(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/subjectCombination?id='+id) );
  }
  deleteBulkTransactions(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/deleteReceiptsByXL/transaction?entity=' +entityId+'&session='+session), fileData)
  }


  //student clubs
  addStudentClub(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/studentClub'), formData)
  }
  editStudentClub(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/studentClub'), formData)
  }
  listStudentClubs(entity,session):Observable<any>{
    return this.http.get<any>(this.URLAddress('/list/studentClub?entity='+entity+'&session='+session))
  }
  listStudentClubsByModerator(entity,session,moderator):Observable<any>{
    let queryParams = entity+'&session='+session
    if(moderator)
      {
        queryParams+='&moderator='+moderator
      }
    return this.http.get<any>(this.URLAddress('/list/studentClub?entity='+queryParams))
  }
  viewStudentClub(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/studentClub?id='+id) );
  }

  //user task management
  addUserTaskManagement(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/userTask'), formData)
  }
  editUserTaskManagement(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/userTask'), formData)
  }
  listUserTaskManagement(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/list/userTask'), formData)
  }
  viewUserTask(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/userTask?id='+id) );
  }
  deleteUserTask(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/userTask?id='+id) );
  }
  sendReminderTaskManagement(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/sendUserTaskReminder/userTask'), formData)
  }

  //excel template

  removeEntityStudent(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/removeEntityStudentsFromODPay/student'),formData) 
  }
  sendPaymentLink(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/sendPaymentLink/communication'), formData)
  }


  listAppliedLeave(entity,session):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/appliedLeave?entity='+entity+'&session='+session+'&pageNumber='+1+'&pageSize='+10))
  }
  sendDueFeeNotification(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/sendDueFee/notifications')),formData)
  }

  getOccupiedSeats(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/getOccupiedSeatCount/subjectCombination')),formData)
  }

  listPartnerCompany(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/partnerCompany?entity='+entityId))
  }
  listPartnerInstitute(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/partnerInstitute?entity='+entityId))
  }

  
  viewAdvancedMaster(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/advancedMaster?entity='+entityId+ '&session='+ session))
  }
  editAdvancedMaster(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/advancedMaster'), formData)
  }
  listResoursePerson(entityId,  formData): Observable<UserData[]>{ 
    return this.http.post<UserData[]>(this.URLAddress('/list/resourcePerson?entity='+entityId), formData)
  }
  addResourcePerson(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/resourcePerson'), formData)
  }
  viewResourcePerson(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/resourcePerson?id='+id))
  }
  editResourcePerson(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/resourcePerson'), formData)
  }
  listSeminar(entityId, startDate, endDate,employee,isAdmin): Observable<UserData[]>{
    let queryParams = entityId+'&startDate='+startDate +'&endDate='+ endDate
    if(employee)
    {
      queryParams +='&employee='+employee
    }
    if(isAdmin)
    {
      queryParams +='&isAdmin='+isAdmin
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/seminar?entity='+queryParams ))
  }
  addSeminar(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/seminar'), formData)
  }
  viewSeminar(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/seminar?id='+id))
  }
  editSeminar(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/seminar'), formData)
  }
  listEvent(formData): Observable<UserData[]>{
    // let queryParams = entityId;
    // if(eventType){
    //   queryParams = queryParams+ '&eventType='+eventType
    // }
    return this.http.post<UserData[]>(this.URLAddress('/list/event'), formData)
  }
  addEvent(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/event'), formData)
  }
  viewEvent(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/event?id='+id))
  }
  editEvent(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/event'), formData)
  }
  listAlumni(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/alumni?entity='+entityId))
  }
  addAlumni(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/alumni'), formData)
  }
  viewAlumni(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/alumni?id='+id))
  }
  editAlumni(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/alumni'), formData)
  }
  uploadAlumni(entityId, formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadSheet/alumni?entity=' +entityId), formData)
  }
  deleteSeminar(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/seminar?id='+id))
  }
  deleteEvent(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/event?id='+id))
  }
  uploadAlumniImage(id, qac, formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadAlumniPhoto?id='+id+'&qac='+qac), formData)
  }
  uploadEventFiles(Id, qac, event,formData,count):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadEventFiles?qac=' +qac+'&id='+Id+'&event='+event+'&maxCount='+count), formData)
  }
  listResearchPublication(entity,startDate,endDate,admin):Observable<UserData[]>{
    let queryParams = entity;
    if(startDate)
    {
      queryParams+='&startDate='+startDate
    }
    if(endDate)
    {
      queryParams+='&endDate='+endDate
    }
    queryParams+='&isAdmin='+admin;
    return this.http.get<UserData[]>(this.URLAddress('/list/researchPublication?entity='+queryParams))
  }
  addPublication(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/researchPublication'), formData)
  }
  editPublication(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/researchPublication'), formData)
  }
  viewResearchPublication(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/researchPublication?id='+id))
  }
  deleteReasearchPublication(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/researchPublication?id='+id))
  }
  uploadMultipleDocuments(qac,fileData,maxCount):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadMultipleDocuments?qac=' +qac+'&maxCount='+maxCount), fileData)
  }

  //book chapter publication
  listBookChapter(entity,startDate,endDate,publicationType,author,isAdmin):Observable<UserData[]>{
    let queryParams = entity +'&startDate='+startDate+'&endDate='+endDate ;
    if(publicationType)
    {
      queryParams+='&publicationType='+publicationType
    }
    if(author)
    {
      queryParams+='&author='+author
    }
    if(isAdmin)
    {
      queryParams+='&isAdmin='+isAdmin
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/bookChapterPublication?entity='+queryParams))
  }
  addChapterBookPublication(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/bookChapterPublication'), formData)
  }
  editChapterBookPublication(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/bookChapterPublication'), formData)
  }
  viewChapterBookPublication(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/bookChapterPublication?id='+id))
  }
  deleteChapterBookPublication(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/bookChapterPublication?id='+id))
  }
  searchEmployee(name, entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/search/employee?search='+name +'&entity=' +entityId+'&session='+session) );
  }
  viewDefaultExcelTemplates(report,entityType): Observable<UserData>{
    let queryParams
    if(report)
    {
      queryParams+='&report='+report
    }
    if(entityType)
    {
      queryParams+='&entityType='+entityType
    }
    return this.http.get<UserData>(this.URLAddress('/viewDefault/defaultExcelTemplate?report='+report+'&entityType='+entityType) );
  }
  listExcelTemplate(entity,report):Observable<any[]>{
    let queryParams = entity
    if(report)
    {
      queryParams+='&report='+report
    }
    return this.http.get<any[]>(this.URLAddress('/list/excelTemplate?entity='+queryParams))
  }
  viewExcelTemplate(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/excelTemplate?id='+id) );
  }

  //workflow
  listWorkflow(id):Observable<any[]>{
    return this.http.get<any[]>(this.URLAddress('/list/workflow?entity='+id))
  }
  addWorkflow(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/workflow'),formData)
  }
  viewWorkflow(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/workflow?id='+id))
  }
  editWorkflow(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/workflow'),formData)
  } 
  updateSection(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateSection/student'), formData)
  }
  updateStream(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateStream/student'), formData)
  }
  updateGroup(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateGroup/student'), formData)
  }
  listSubjectCombinations(entityId, session,course,stream,batch): Observable<UserData[]>{
    let queryParams = 'entity='+ entityId+'&session='+session;
    if(course){
      queryParams = queryParams + '&course='+encodeURIComponent(course);
    }
    if(stream){
      queryParams = queryParams + '&stream='+stream;
    }
    if(batch)
    {
      queryParams = queryParams+'&batch='+batch;
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/subjectCombination?'+queryParams))
  }
  viewPDFDefaultTempaltes(entityType,reportName): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/viewDefault/defaultPDFTemplate?report='+reportName+'&entityType='+entityType));
  }
  viewDefaultTemplate(entity,name,course):Observable<any>{
    let queryParams = entity+'&report='+name
    if(course){
      queryParams+='&course='+encodeURIComponent(course)
    }
    return this.http.get<any>(this.URLAddress('/viewDefault/pdfTemplate?entity='+queryParams));
  }
  uploadStudentUtilityPhoto(id, qac, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadStudentPhoto?id=' +id+'&qac='+qac), fileData)
  }
  getSubjectsByCourse(entityId, session, course, stream, batch, section):Observable<UserData>{
    let queryParams = 'entity='+ entityId+'&session='+session;
    if(course){
      queryParams = queryParams + '&course='+encodeURIComponent(course);
    }
    if(stream){
      queryParams = queryParams + '&stream='+stream;
    }
    if(batch){
      queryParams = queryParams + '&batch='+batch;
    }
    if(section){
      queryParams = queryParams + '&section='+section;
    }
    return this.http.get<UserData>(this.URLAddress('/getSubjectsByCourse/subjectCourseMapping?'+queryParams))
  }
  getStudentAttendanceValue(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/studentSummary/studentAttendance'),formData)
  }
  getStudentAttendanceValueNew(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/studentSummary/studentAttendanceNew'),formData)
  }
  getAppliedLeave(entity,session,student):Observable<any>{
    return this.http.get<any>(this.URLAddress('/list/appliedLeave?entity='+entity+'&session='+session+'&student='+student))
  }
  getStudentAssessmentMarks(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/studentAssessmentMarks/assessmentMarks'),formData)
  }
  getSubjectWiseAttendance(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/subjectWiseAttendance/studentAttendance?studentAttendance='+id))
  }
  getSubjectWiseAttendanceNew(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/subjectWiseAttendance/studentAttendanceNew?studentAttendance='+id))
  }
  listCommunicationReport(entityId,session,pageNumber,pageSize,startDate,endDate,category,student,communicationType): Observable<UserData>{
    let queryParams = entityId +'&session='+session +"&startDate="+startDate+"&endDate="+endDate
  
    if(pageNumber)
    {
      queryParams = queryParams + '&pageNumber='+pageNumber
    }
    if(pageSize)
    {
      queryParams = queryParams + '&pageSize='+pageSize
    }
    if(category){
      queryParams = queryParams + '&category='+category
    }
    if(student){
      queryParams = queryParams +'&studentId='+student
    }
    if(communicationType){
      queryParams =queryParams +'&communicationType='+communicationType
    }

    return this.http.get<UserData>(this.URLAddress('/list/communicationReport?entity='+queryParams))
  }
  getIssueRecordsByReceiverId(entityId, id, issueType, receiverCode, department):Observable<UserData[]>{
    let queryParams ='entity='+ entityId+'&receiverCode='+receiverCode;
    if(id){
      queryParams +='&receiverId='+id
    }
    if(issueType){
      queryParams +='&issueType='+issueType
    }
    // if(receiverCode){
    //   queryParams = queryParams+ 'receiverCode='+receiverCode+'&issueType='+issueType
    // }
    if(department){
      queryParams +='&receiverName='+department
    }
    return this.http.get<UserData[]>(this.URLAddress('/getIssueRecordsByReceiverId/libraryBook?'+ queryParams))
  }
  listAssessmentGroup(entityId, session, course, stream, batch): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/assessmentGroup?entity='+entityId+ '&session='+ session+'&course='+encodeURIComponent(course)+'&stream='+stream+'&batch='+batch))
  }
  listAssessmentGradeSetup(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/assessmentGradeSetup?entity='+entityId+ '&session='+ session))
  }
  editStudentMaster(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/studentMaster'), formData)
  }
  getCoursesByTeacher(entityId, session, attendanceType,teacher,isAdmin): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+session+'&teacher='+teacher+ '&attendanceType='+attendanceType
    if(isAdmin){
      queryParams = queryParams + '&isAdmin='+isAdmin
    } 
    return this.http.get<UserData[]>(this.URLAddress('/getCoursesByTeacher/subjectCourseMapping?entity='+queryParams))
  }
  getCoursesByModerator(entityId, session, attendanceType,moderator,isAdmin): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+session+'&moderator='+moderator+ '&attendanceType='+attendanceType
    if(isAdmin){
      queryParams = queryParams + '&isAdmin='+isAdmin
    } 
    return this.http.get<UserData[]>(this.URLAddress('/getCoursesByTeacher/subjectCourseMapping?entity='+queryParams))
  }
  addStudentsXL(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/addStudentsXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  deleteBulkStudents(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/deleteStudentsByXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  updateStudentsXL(entityId, session, fileData , resetDemand): Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateStudentsXL/student?entity=' +entityId+'&session='+session +'&resetDemand='+resetDemand), fileData)
  }
  updateStudentDetailsXL(entityId, session, label, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateStudentDetailsXL/student?entity=' +entityId+'&session='+session+'&label='+label), fileData)
  }
  updateStudentDemandExcel(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateStudentDemandXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  addStudentDemandExcel(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/addStudentDemandXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  updateStudentSessionData(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateStudentSessionDataXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  uploadStudentConcessionXl(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/assignStudentConcessionXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  uploadSiblingExcel(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/saveSiblingsXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  updateStudentsRegNo(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateRegNoXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  uploadStudentImages(entityId,qac, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadImages/student?entity=' +entityId+'&session='+session+'&qac='+qac), fileData)
  }
  uploadParentImages(entityId,qac,fieldName, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadParentImages/student?entity=' +entityId+'&session='+session+'&qac='+qac+'&fieldName='+fieldName), fileData)
  }
  uploadTransportExcel(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadTransportXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  removeHostel(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/removeFromStudent/hostelRoom?studentId'),formData)
  }
  assignHostel(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/assignToStudent/hostelRoom'),formData)
  }
  listHostelRoom(id, hostelRoom, roomType, session): Observable<any> {
    let hostelArr = hostelRoom ? (Array.isArray(hostelRoom) ? hostelRoom : [hostelRoom]) : [];
    let roomTypeArr = roomType ? (Array.isArray(roomType) ? roomType : [roomType]) : [];
    let body: any = {
      entity: id,
      session: session
    };
    if (hostelArr.length > 0) {
      body.hostel = hostelArr;
    }
    if (roomTypeArr.length > 0) {
      body.roomType = roomTypeArr;
    }
    return this.http.post<any>(this.URLAddress('/list/hostelRoom'), body);
  } 
   addVehicleRoute(vehicleData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/vehicleRoute'), vehicleData)
  }
  viewVehicleRoute(vehicleId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/vehicleRoute?id='+vehicleId))
  }
  deleteVehicleRoute(vehicleId,entityId,session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/vehicleRoute?id='+vehicleId+ '&entity='+entityId+ '&session=' +session))
  }
  assignVehicleRoute(transportData):  Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/assignTransport/student'), transportData)
  }
  removeTransport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/removeTransport/student'),formData)
  }
  uploadStudentDocuments(id, qac, fileData,entityId,regNo): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadStudentDocuments?id=' +id+'&qac='+qac+'&entity='+entityId+'&regNo='+regNo), fileData)
  }
  checkIssuedRecordsCount(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/checkIssuedRecordsCount/libraryBook?id='+id))
  }
  studentLedger(id, date): Observable<any>{
    return this.http.get<any>(this.URLAddress('/studentLedger/student?id=' +id+'&date='+date))
  }
  getTuitionFee(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/getTuitionFee/student'), formData)
  }
  viewStudentDatas(studentId, entityId, session, regNo): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/student?id='+studentId+ '&entity=' +entityId+'&session='+session+ '&regNo='+regNo) );
  }
  deleteConcessionRemark(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/deleteConcession/student'),formData)
  }
  deleteStudent(id): Observable<any>{
    return this.http.get<any>(this.URLAddress('/delete/student?id=' +id))
  }
  viewHostelMaster(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/hostelMaster?entity='+id))
  }
  listVehicleRoute(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/vehicleRoute?entity='+entityId+ '&session=' +session))
  }
  studentAddToSession(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/addToSession/student'), formData)
  }
  addReportFile(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/reportFile'), formData).pipe(
      tap(() => this.reportNotificationService.notifyReportGenerated())
    )
  }
  getAdmissionWithdrawalReport(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/admissionWithdrawalReport/studentReports'),formData)
  }
  getGenderWiseCategoryReport(entity,session,label):Observable<any>{
    return this.http.get<any>(this.URLAddress('/genderCategoryStrengthReport/studentReports?entity='+entity+'&session='+session+'&label='+label))
  }
  studentStrengthReport(entityId, session, label,awakeStartDate,awakeEndDate):Observable<UserData[]>{
    let queryParams = 'entity='+ entityId+'&session='+session+'&label='+label;
    if(awakeStartDate){
      queryParams = queryParams + '&awakeStartDate='+awakeStartDate;
    }
    if(awakeEndDate){
      queryParams = queryParams + '&awakeEndDate='+awakeEndDate;
    }
    return this.http.get<UserData[]>(this.URLAddress('/strengthReport/studentReports?'+queryParams))
  }
  getStudentFeedbackReport(entityId,studentId,userName,mobile,selectedFeedbackCategory,selectedFeedbackType,selectedPrivacy,startDate,endDate,value,pageSize,pageNumber):Observable<UserData[]>{
    let queryParams = 'entity='+ entityId
    if(userName){
      queryParams = queryParams + '&userName='+userName;
    }
    if(mobile){
      queryParams = queryParams + '&userMobile='+mobile;
    }
    if(studentId){
      queryParams = queryParams + '&studentDetailsId='+studentId;
    }
    if(selectedPrivacy){
      queryParams = queryParams + '&privacy='+selectedPrivacy;
    }
    if(selectedFeedbackCategory){
      queryParams = queryParams + '&category='+selectedFeedbackCategory;
    }
    if(selectedFeedbackType){
      queryParams = queryParams + '&feedbackType='+selectedFeedbackType;
    }
    if(startDate){
      queryParams = queryParams + '&startDate='+startDate;
    }
    if(endDate){
      queryParams = queryParams + '&endDate='+endDate;
    }
    if(value){
      queryParams = queryParams + '&isReport='+value;
    }
    if(pageSize)
    {
      queryParams+='&pageSize='+pageSize
    }
    if(pageNumber)
    {
      queryParams+='&pageNumber='+pageNumber
    }
    
    return this.http.get<UserData[]>(this.URLAddress('/list/studentTimeline?'+queryParams))
  }
  listTransportOccupancy(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/transportOccupancy/studentReports'),formData)
  }
  transportReport(entityId, session, formData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/transportReport/studentReports?entity=' +entityId+'&session='+session), formData)
  }
  listCommunicationTemplate(entityId, eventType, channel):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/communicationTemplate?entity='+entityId+'&eventType='+eventType+ '&channel='+channel))
  }
  viewCommunicationConfig(entityId, session):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/communicationConfig?entity='+entityId+'&session='+session))
  }
  sendTransportSMSCommunication( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendTransportSMS/communication'), formData)
  }
  sendSMSTransportNotification(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/sendTransport/notifications'),formData)
  }
  addStudentConcessionExcel(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/addStudentConcessionXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  updateStudentConcessionExcel(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateStudentConcessionXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  setFormatData(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/setDataFormat/student'),formData)
  }
  listSharePoint(entityId, fileType, folder,pageSize,pageNumber): Observable<UserData[]>{
    let queryParms = entityId;
    queryParms = queryParms + '&fileType=' +fileType;
    if(folder){
      queryParms = queryParms + '&folder=' +folder;
    }
    if(pageSize)
    {
      queryParms = queryParms + '&pageSize=' +pageSize;
    }
    if(pageNumber)
    {
      queryParms = queryParms + '&pageNumber=' +pageNumber;
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/sharePoint?entity='+queryParms))
  }
  addSharePoint(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/sharePoint'), formData)
  }
  viewSharePoint(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/sharePoint?id='+id))
  }
  editSharePoint(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/sharePoint'), formData)
  }
  uploadSharePoint(Id, qac, formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadSharePoint?id=' +Id+'&qac='+qac), formData)
  }
  listHRMLeaveCycle(entity): Observable<UserData[]> {
    return this.http.get<UserData[]>(this.URLAddress('/list/hrmLeaveCycle?entity=' + entity))
  }
  uploadRoomCharges(id,fileData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadRoomChargesXL/hostelRoom?id=' +id), fileData)
  }
  importHostelWithBeds(id,fileData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadHostelRoomsXL/hostelRoom?entity=' +id), fileData)
  }
  importHostelRoomCharges(id,session,fileData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadMultipleRoomChargesXL/hostelRoom?entity=' +id+'&session='+session), fileData)
  }
  addHostelRoom(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/hostelRoom'),formData)
  }
  editHostelRoom(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/hostelRoom'),formData)
  }
  viewHostelRoom(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/hostelRoom?id='+id))
  }
  editMultipleRooms(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/editMultiple/hostelRoom')),formData)
  }
  listEmployee(entityId, role, department, status): Observable<UserData[]> {
    let queryParams = entityId;
    if (role) {
      queryParams = queryParams + '&role=' + role;
    }
    if (department) {
      queryParams = queryParams + '&department=' + department;
    }
    if (status != undefined) {
      queryParams = queryParams + '&status=' + status;
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/Employee?entity=' + queryParams + '&showInactive=' + true))
  }
  listEmployees(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/Employee?entity='+entityId))
  }
  editHostelMaster(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/hostelMaster'),formData)
  }
  updateAllEntityGroup(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateAllEntityGroup/hostelRoom'),formData)
  }
  allocateHostels(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/assignToStudentsXL/hostelRoom?entity=' +entityId+'&session='+session), fileData)
  }
  editExcelTemplate(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/excelTemplate'), formData)
  }
  addExcelTemplate(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/excelTemplate'), formData)
  }
  deleteExcelTemplate(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/excelTemplate?id='+id) );
  }
  processStudentLedgersMultipleSession(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/studentLedgerAllSession/student'),formData)
  }
  processStudentLedgersMultipleSessionHeadWise(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/studentLedgerHeadWiseAllSession/student'),formData)
  }
  editHostelRoomName(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/editName/hostelRoom'),formData)
  }
    //website crud
    updateEntityWebsiteCrud(formData):Observable<any>{
      return this.http.post<any>((this.URLAddress('/edit/entityWebsiteConfig')),formData)
    }  
    viewEntityWebsiteCrud(entityId): Observable<EntityWebsiteModel>{
      return this.http.get<EntityWebsiteModel>(this.URLAddress('/view/entityWebsiteConfig?entity='+entityId) );
    }
    uploadCourseExcel(entity,session,formData): Observable<UserData[]>{
      return this.http.post<UserData[]>(this.URLAddress("/uploadSheet/course?entity="+entity+'&session='+session),formData);
    }
    openDefaultTemplate(entity,reportName,course): Observable<UserData[]>{
      return this.http.get<UserData[]>(this.URLAddress('/openDefaultPDFTemplates?entity='+entity+'&report='+reportName+'&course='+encodeURIComponent(course)) );
    }
    viewPDFTemplate(id):Observable<any>{
      return this.http.get<any>(this.URLAddress('/view/pdfTemplate?id='+id))
    }
    viewFeeGroupByCourse(formData): Observable<UserData>{
      return this.http.post<UserData>(this.URLAddress("/viewByCourse/feeGroup"),formData);
    }
    fetchSession(entity,session) :Observable<UserData>{
      return this.http.get<UserData>(this.URLAddress('/fetch/session?entity='+entity+'&session='+session))
    }
    listAllRoles():Observable<UserData[]>{
      return this.http.get<UserData[]>(this.URLAddress('/listRoles/allPermissions'))
    }
    listRoleBasedPermission(entity,userId,role):Observable<UserData[]>{
      if(entity){
      return this.http.get<UserData[]>(this.URLAddress('/listRolePermissions/allPermissions?entity='+entity+'&userId='+userId+'&role='+role))
      }else{
      return this.http.get<UserData[]>(this.URLAddress('/listRolePermissions/allPermissions?userId='+userId+'&role='+role))
      }
    }
    listLoggedInUserAllPermissions(id):Observable<UserData[]>{
      return this.http.get<UserData[]>(this.URLAddress('/listUserPermissions/allPermissions?userId='+id))
    }
    viewHrmPayrollMaster(entityId): Observable<any> {
      return this.http.get<any>(this.URLAddress('/view/hrmPayrollMaster?entity=' + entityId));
    }
    getEdrReport(formData):Observable<any>{
      return this.http.post<any>(this.URLAddress('/edrReport/studentAttendance'),formData)
    }
    listLessonCrud(formData):Observable<any>{
      return this.http.post<any>(this.URLAddress('/list/lessonPlan'),formData)
    } 
  listQueries(formData): Observable<ParentStudentModel[]>{
    return this.http.post<ParentStudentModel[]>(this.URLAddress('/listQueries/odPay'),formData)
  }
      listAllPermission():Observable<UserData[]>
      {
        return this.http.get<UserData[]>(this.URLAddress('/list/allPermissions'))
      }
      getAttendanceSummary(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/studentSummary/studentAttendanceV3'),formData)
      }
      listWebTab(entity):Observable<any>{
        return this.http.get<any>(this.URLAddress('/list/webTabs?entity='+entity))
      }
      addWebTab(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/add/webTabs'),formData)
      }
      viewWebTab(id):Observable<any>{
        return this.http.get<any>(this.URLAddress('/view/webTabs?id='+id))
      }
      deleteWebTab(id):Observable<any>{
        return this.http.get<any>(this.URLAddress('/delete/webTabs?id='+id))
      }
      editWebTab(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/edit/webTabs'),formData)
      }
      deleteCourseData(id):Observable<any>{
        return this.http.get<any>(this.URLAddress('/delete/course?id='+id))
      }
      getListStudentClubAttendance(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/getList/studentClubAttendance'),formData)
      }
      saveClubAttendance(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/saveList/studentClubAttendance'),formData)
      }
      listMarkedReportClubAttendance(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/markedReport/studentClubAttendance'),formData)
      }
      getEmployeeBirthday(entityId):Observable<UserData[]>
      {
        return this.http.get<UserData[]>(this.URLAddress('/currentMonthBirthday/employee?entity='+entityId))
      }
      bulkUpdateBranchId(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateStudentBranchIdXL/student?entity=' +entityId+'&session='+session), fileData)
     }
        viewExpenseManagementMaster(entityId): Observable<ExpenseModel>{
          return this.http.get<ExpenseModel>(this.URLAddress('/view/expenseManagementMaster?entity='+entityId))
        }
      viewIntegrationMaster(entity):Observable<any>{
        return this.http.get<any>(this.URLAddress('/view/integrationMaster?entity='+entity))
      }
      editIntegrationMaster(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/edit/integrationMaster'),formData)
      }
      listClubAttendanceSummaryReport(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/summaryReport/studentClubAttendance'),formData)
      }
      listCategory(formData): Observable<ParentStudentModel>{
        return this.http.post<ParentStudentModel>(this.URLAddress('/listCategories/odPay'),formData)
      }
      listStudentQueryMapper(entity,category,subcategory):Observable<UserData[]>
      {
        let queryParams = entity
        if(category)
        {
          queryParams=queryParams+'&category='+category;
        }
        if(subcategory)
        {
          queryParams=queryParams+'&subCategory='+subcategory
        }
        return this.http.get<UserData[]>(this.URLAddress('/list/studentQueryMapper?entity='+queryParams))
      }
      addStudentQueryMapper(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/add/studentQueryMapper'),formData)
      }
      editStudentQueryMapper(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/edit/studentQueryMapper'),formData)
      }
      viewStudentQueryMapper(id):Observable<any>{
        return this.http.get<any>(this.URLAddress('/view/studentQueryMapper?id='+id))
      }
      deleteStudentMapper(id):Observable<any>{
        return this.http.get<any>(this.URLAddress('/delete/studentQueryMapper?id='+id))
      }

       listStudentQuery(entity,session,category,subcategory,status,studentId,isAdmin?: boolean): Observable<ParentStudentModel[]>{
        let queryParam = entity;
        if (session) {
          queryParam = queryParam + '&session=' + session;
        }
          if(category)
          {
            queryParam = queryParam+'&category='+category
          }
          if(subcategory)
          {
            queryParam = queryParam+'&subCategory='+subcategory;
          }
          if(status)
          {
            queryParam = queryParam+'&status='+status;
          }
          if(studentId)
          {
            queryParam = queryParam +'&studentId='+studentId
          }
          if(isAdmin)
          {
            queryParam = queryParam +'&isAdmin='+isAdmin;
          }
          return this.http.get<ParentStudentModel[]>(this.URLAddress('/list/studentQuery?entity='+queryParam))
        }
        viewStudentQuery(id): Observable<ParentStudentModel>{
          return this.http.get<ParentStudentModel>(this.URLAddress('/view/studentQuery?id='+id))
        }
        replyQuery(formData): Observable<ParentStudentModel>{
          return this.http.post<ParentStudentModel>(this.URLAddress('/reply/studentQuery'),formData)
        }
        resolveQuery(formData): Observable<ParentStudentModel>{
          return this.http.post<ParentStudentModel>(this.URLAddress('/resolve/studentQuery'),formData)
        }
        addStudentQuery(formData): Observable<ParentStudentModel[]>{ //?subject= for roleType
          return this.http.post<ParentStudentModel[]>(this.URLAddress('/add/studentQuery?subject='+formData.subject),formData)
        }
        editStudentQuery(formData): Observable<ParentStudentModel[]>{
          return this.http.post<ParentStudentModel[]>(this.URLAddress('/edit/studentQuery'),formData)
        }

  
        sendMultipleStudentAlertReminder(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleStudentAlertWhatsApp/communication'), formData)
  }
      viewComplianceCertificate(id):Observable<any>{
        return this.http.get<any>(this.URLAddress('/view/complianceCertificate?id='+id))
      }
      listComplianceCertificate(entity,name,startDate,endDate,expiryStatus):Observable<any>{
        let queryParams = entity;
        if(name)
        {
          queryParams+='&name='+name;
        }
        if(startDate)
        {
          queryParams+='&startDate='+startDate;
        }
        if(endDate)
        {
          queryParams+='&endDate='+endDate;
        }
        if(expiryStatus)
        {
          queryParams+='&expiryStatus='+expiryStatus;
        }
        return this.http.get<any>(this.URLAddress('/list/complianceCertificate?entity='+queryParams))
      }
      addComplianceCertificate(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/add/complianceCertificate'),formData)
      }
      editComplianceCertificate(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/edit/complianceCertificate'),formData)
      }
     deleteComplianceCertificate(id):Observable<any>{
        return this.http.get<any>(this.URLAddress('/delete/complianceCertificate?id='+id))
      }

      viewAdmissionTransactionList(entityId, session, studentId): Observable<UserData[]>{
        let queryParams = entityId+'&session='+session;
        if(studentId){
          queryParams = queryParams+'&studentData='+studentId
        }
        return this.http.get<UserData[]>(this.URLAddress('/list/admissionTransaction?entity='+queryParams))
      }


      searchStudentWithCourse(name, entityId, session,course,stream,batch,section): Observable<UserData[]>{
        return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+name +'&entity=' +entityId+'&session='+session+'&course='+course+'&stream='+stream+'&batch='+batch+'&section='+section) );
      }
      searchStudentSearchBy(name, entityId, session,searchBy,isHostel): Observable<UserData[]>{
        let queryParms = name+ '&entity=' +entityId+ '&session=' +session;
        if(searchBy){
          queryParms = queryParms+'&searchBy=' + searchBy;
        }
        if(isHostel){
          queryParms = queryParms+'&isHostel=' + isHostel;
        }
        return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+queryParms) );
      }
      listLibraryMember(entityId): Observable<UserData[]>{
        return this.http.get<UserData[]>(this.URLAddress('/list/libraryMember?entity='+entityId))
      }
      searchEmployeeWithInactive(name, entityId, session,includeInactive): Observable<UserData[]>{
        let queryParams = name +'&entity=' +entityId+'&session='+session
        if(includeInactive)
        {
          queryParams+='&includeInactive='+includeInactive
        }
        return this.http.get<UserData[]>(this.URLAddress('/search/employee?search='+queryParams) );
      }

    

      viewDefaultMarkedAttachmentTemplate(report,entityType,course)
      {
            let queryParams = report;
        if(entityType)
        {
          queryParams +='&entityType='+entityType
        }
        if(course)
        {
          queryParams +='&course='+course
        }
        return this.http.get<any[]>(this.URLAddress('/viewDefault/defaultAttachmentTemplate?report='+queryParams));
      }
    
        addUserLogs(formData):Observable<any>{
          return this.http.post<any>((this.URLAddress('/add/userLogs')),formData)
        }

      getSeatOccupancyVehicle(formData):Observable<any>{
        return this.http.post<any>(this.URLAddress('/getSeatOccupancy/vehicleRoute'),formData)
      }
        viewDefaultMarkedEntityAttachmentTemplate(entity,name,course):Observable<any>{
        let queryParams = entity+'&report='+name
        if(course){
          queryParams+='&course='+encodeURIComponent(course)
        }
        return this.http.get<any>(this.URLAddress('/viewDefault/attachmentTemplate?entity='+queryParams));
      }
      getPresignedUrl(qac,formData):Observable<any>{
        return this.http.post<any>(this.URLAddress("/getPresignedUrl?qac="+ qac),formData);
      }
      getPresignedMultiple(qac,formData):Observable<any>{
        return this.http.post<any>(this.URLAddress("/getMultiplePresignedUrls?qac="+ qac),formData);
      }
      viewConcession(id): Observable<UserData> {
       return this.http.get<UserData>(this.URLAddress('/view/studentConcession?id=' + id))
      }
      viewAssessmentMaster(id, session):Observable<UserData>{
        return this.http.get<UserData>(this.URLAddress('/view/assessmentMaster?entity='+id+'&session='+session))
      }
      saveBonafiedCharacterStudentCertificate(payload): Observable<any>{
        return this.http.post<any>(this.URLAddress('/saveBonafiedCharacterStudentCertificate/studentCertificate'), payload);
      }
}